import type {ReactElement} from 'react';
import React from 'react';
import {AiChatWindow} from '@Components/ai-chat-window/ai-chat-window';
import {useSingleActivePosterItemId} from "@Hooks/poster-editor/useSingleActivePosterItemId";

// zain todo: wip
export function IneditorChatPanel(): ReactElement<any> {
    const activeItemId = useSingleActivePosterItemId() ?? '';
    console.log('activeItemId', activeItemId);
    const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;

    return (
    // <AiChatProvider>
    //   <AiChatBody isSuperUser={true} chatOnLoadParams={{userRequestParts: []}} />{' '}
    // </AiChatProvider>
    <div className="spacing-p-l-2 spacing-p-r-2 _full-height">
      <AiChatWindow />
    </div>
  );
}
